import { api_GET, api_POST } from "api/_axios.js";

const indicesextras_api =
{
    get: function (grupoeconomico) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`indicesextras/${encodeURIComponent(grupoeconomico)}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`indicesextras`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default indicesextras_api
